import {
  FaYoutube,
  FaInstagram,
  FaFacebook,
  FaSpotify,
  FaTiktok,
  FaTwitter,
  FaSoundcloud,
  FaApple,
  FaGlobe,
  FaLink,
} from "react-icons/fa";

export const ICONS = {
  youtube: FaYoutube,
  instagram: FaInstagram,
  facebook: FaFacebook,
  spotify: FaSpotify,
  tiktok: FaTiktok,
  twitter: FaTwitter,
  soundcloud: FaSoundcloud,
  apple: FaApple,
  website: FaGlobe,
  link: FaLink,
};

export const ICON_LABELS = {
  youtube: "YouTube",
  instagram: "Instagram",
  facebook: "Facebook",
  spotify: "Spotify",
  tiktok: "TikTok",
  twitter: "X / Twitter",
  soundcloud: "SoundCloud",
  apple: "Apple Music",
  website: "Website",
  link: "Other link",
};

export const ICON_OPTIONS = Object.keys(ICONS);
